<template>
  <v-container>
    <v-form v-model='isFormValid' ref='form'>
      <v-row justify='center'>
        <v-col cols='12' sm='6' md='4' lg='3'>
          <v-card outlined :loading='isLoading'>
            <v-card-text class='text-center'>
              <h2>
                <span class='primary--text'>CPM </span>
                <span class='info--text text--lighten-2'>2.0</span>
              </h2>
              <br>
              <span class='subheading grey--text'>Enter the email address connected to your account.</span><br>
              <br>
              <v-text-field v-model='userEmail' :rules='[rules.emailRequired]' label='email address'></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn color='error' text :disabled='processing' :to="{ name: 'Login' }">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color='info' depressed :disabled='!isFormValid' @click='sendReset' :loading='processing'>Reset Password</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>

    <wc-dialog
      title='Email Sent'
      icon='mdi-send'
      :showDialog='showLogin'
      width='350'
      hideCancel
      saveText='Login'
      @save='goToLogin'
    >
      Check your email for a new password, and login using that new password.<br>
      <br>
      If you did not receive an email, your email address may not have been found on the system. If
      that's the case, check with the office for help. 
    </wc-dialog>
  </v-container>
</template>

<script>
import formRules from '@/mixins/formRules'
import authAPI from '@/api/auth'

export default {
  name: 'forgot-password',
  mixins: [formRules],
  data: () => ({
    processing: false,
    showLogin: false,
    isFormValid: false,
    isLoading: false,
    userEmail: ''
  }),
  methods: {
    sendReset () {
      this.processing = true
      var tmp = {
        email: this.userEmail
      }
      // auth.forgotPassword(tmp)
      authAPI.forgotPassword(tmp)
      this.processing = false
      this.showLogin = true
      this.userEmail = ''
      this.$refs.form.resetValidation()
    },
    goToLogin () {
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>